var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sh-api-intro-card',{attrs:{"content-path":"/api-intro.html"}})
}
var staticRenderFns = []

export { render, staticRenderFns }